/* import __COLOCATED_TEMPLATE__ from './sq-form.hbs'; */
/**
## sq-form

This component wraps [`sq-form-field`](/components/glass/sq-form-field.html)s and does the following:

1. Calls a passed `onSubmit` action on submit
2. Passes a flash context to its yielded fields, which they can use to update the
current error message on focus

```example
@controller-properties
{
  focusedMessage: 'null',

  setFocusedMessage(message) {
    this.set('focusedMessage', message);
  },

  clearFocusedMessage() {
    this.set('focusedMessage', null);
  },

  actions: {
    save() {
      alert('You got saved!');
    }
  }
}

@hbs
<p class="form-helptext form-helptext--intro">
  <strong>Focused message:</strong> {{focusedMessage}}
</p>

{{#sq-form flashContext=this
           onSubmit=(action "save")
           as |form|}}
  <div class="form-table">
    {{#form.field label="First Name" errorMessage="First name is messed!"}}
      {{sq-field-input placeholder="First Name"}}
    {{/form.field}}
    {{#form.field label="Last Name" errorMessage="Last name is messed!"}}
      {{sq-field-input placeholder="Last Name"}}
    {{/form.field}}
  </div>
  <button type="submit" style="margin-top: 10px">Hit Enter To Submit!!</button>
{{/sq-form}}
```

##  Usage with Top Label Form Variant

Tge [`sq-form-field`](/components/glass/sq-form-field.html) top label variant relies on [`.responsive-columns`](/glass/docs/core-styling/responsive-columns.html) for layout,
but you need to wrap it in an element that has the `.reponsive-columns` class on it in order for the grid to work.
Passing `useTopLabelVariant` to `sq-form` will add this class to the resulting `form` element, and also passes
down the `useTopLabelVariant` to all yielded fields, so you don't have to pass it to each one of them individually.

```example
@hbs
{{#sq-form useTopLabelVariant=true
           as |form|}}
  {{#form.field label="First Name"}}
    {{sq-field-input placeholder="Matt"}}
  {{/form.field}}
  {{#form.field label="Last Name"}}
    {{sq-field-input placeholder="Wright"}}
  {{/form.field}}
{{/sq-form}}
```

### Parameters
@param {Object} flashContext - flash context to pass to form fields. One of `flash.contexts.global`, `flash.contexts.sheet` or `flash.contexts.modal`
@param {Function} onSubmit - Action to call on submit. Allows the form to be sumbitted when enter is hit.
@param {Boolean} [useTopLabelVariant=false] - Triggers the top label form variant UI. This flag will also be passed down to the yielded field components.
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'form',
  classNameBindings: ['useTopLabelVariant:sq-form--top-label', 'useTopLabelVariant:responsive-columns'],
  // Passed in
  flashContext: null,
  useTopLabelVariant: false,
  submit(e) {
    // Prevent page refresh
    e.preventDefault();
    this.onSubmit();
  }
});